import { render, staticRenderFns } from "./update-traitement-modal.vue?vue&type=template&id=5879e99e&scoped=true"
import script from "./update-traitement-modal.vue?vue&type=script&lang=js"
export * from "./update-traitement-modal.vue?vue&type=script&lang=js"
import style0 from "./update-traitement-modal.vue?vue&type=style&index=0&id=5879e99e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879e99e",
  null
  
)

export default component.exports